var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgToTheCenter = function SvgToTheCenter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20 20 8 8m-8-8v6.4m0-6.4h6.4M12 26.4V20m0 0H5.6m6.4 0-8 8M20 5.6V12m0 0h6.4M20 12l8-8M12 5.6V12m0 0H5.6m6.4 0L4 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgToTheCenter);
export default ForwardRef;